// React
import React from 'react';

// Packages

// Utilities
import { useActivityTagging, useContext } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';
import { useInitiativeDataStore } from 'utilities/store';

// Components
import {
    ActivityMetrics,
    ActivityReflections,
    ActivityDetails,
    ActivityChoice,
    ActivityDataCard,
    ActivitySetFieldValues,
} from '../_common';

const Name = CONSTANTS.ACTIVITIES.TEACHING;

const Choice = props => {
    return ActivityChoice({
        Name,
        methods: 'Initiative_Activity__c.Teaching_Type__c',
        fieldName: 'Teaching_Type__c',
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { utilities } = useInitiativeDataStore();

    // ///////////////////
    // DATA
    // ///////////////////

    const tagTypes =
        utilities.initiative.get().Configuration_Type__c ===
        CONSTANTS.INITIATIVE.CSLT
            ? [CONSTANTS.TAGS.TEACHING_ACTIVITY_CAPACITY]
            : [CONSTANTS.TAGS.TEACHING_ACTIVITY];

    // ///////////////////
    // RETURN
    // ///////////////////

    return (
        <ActivityDataCard
            {...{
                item,
                theme,
                methodsFieldName: 'Teaching_Type__c',
                tagTypes,
                showTags: mode.includes('tags'),
                showDetails: mode.includes('details'),
            }}
        />
    );
};

const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { utilities } = useInitiativeDataStore();
    const tagging = useActivityTagging({
        types:
            utilities.initiative.get().Configuration_Type__c ===
            CONSTANTS.INITIATIVE.CSLT
                ? [CONSTANTS.TAGS.TEACHING_ACTIVITY_CAPACITY]
                : [CONSTANTS.TAGS.TEACHING_ACTIVITY],
    });

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        const { Teaching_Type__c } = formData;

        // Data for sf
        return {
            Teaching_Type__c,
        };
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ActivityDetails({
        tagging: tagging.activity,
        getItemData,
        ...props,
    });
};

const Metrics = props => {
    return ActivityMetrics({
        Name,
        primary: true,
        secondary: true,
        ...props,
    });
};

const Reflections = props => {
    return ActivityReflections({
        primary: true,
        secondary: true,
        ...props,
    });
};

const setFieldValues = ({
    tagging,
    choice,
    form,
    id,
    utilities,
    REPORT_ID,
}) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const { Teaching_Type__c } = utilities.activities.get(id);

    // Choice
    form.setValue('Teaching_Type__c', Teaching_Type__c);

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ActivitySetFieldValues({
        REPORT_ID,
        tagging,
        choice,
        form,
        id,
        utilities,
    });
};

export {
    Name,
    DataCard,
    Choice,
    Details,
    Metrics,
    Reflections,
    setFieldValues,
};
